import GalleryServer from "../../server/gallery";
import OutputGalleryEntry, {
  RequestGalleryEntriesByStructure,
} from "../../dtos/gallery";
import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "..";

class GalleryServiceReader extends ServiceReader {
  constructor(protected api: GalleryServer) {
    super();
  }

  public async byStructure(strucutreId: string): Promise<OutputGalleryEntry[]> {
    const raw = await this.api.get(
      new RequestGalleryEntriesByStructure(strucutreId)
    );
    if (!Array.isArray(raw))
      throw new TypeError("Gallery entry list is not an array.");

    return raw.map((value) => OutputGalleryEntry.convert(value));
  }
}

class GalleryServiceCreator extends ServiceCreator {}
class GalleryServiceUpdater extends ServiceUpdater {}
class GalleryServiceDeleter extends ServiceDeleter {}

export default class GalleryService extends Service {
  constructor() {
    super(new GalleryServer());
  }

  public get read(): GalleryServiceReader {
    return new GalleryServiceReader(this.api as GalleryServer);
  }
  public get create(): ServiceCreator {
    return new GalleryServiceCreator();
  }
  public get update(): ServiceUpdater {
    return new GalleryServiceUpdater();
  }
  public get delete(): ServiceDeleter {
    return new GalleryServiceDeleter();
  }
}
